<template lang="pug">
#modal-cancelamento-operacao
    el-dialog(
        :title="$t('mensagens.operacao.cancelarOperacao')",
        width='610px',
        :visible='show',
        @close='closeDialog()'
    )
        h4.mb-4 {{ $t('mensagens.operacao.cancelamentoIrreversivel') }}
        p
            b {{ $t('mensagens.operacao.nomeOperacao') }}:
            |
            | {{ operacao.nome }}

        el-form(label-position='top', size='small')
            .row
                .col-12
                    el-form-item
                        template(slot='label')
                            span {{ $t('mensagens.operacao.justificativa') }}

                        el-input(
                            v-model='justificativa',
                            :maxlength='255',
                            :placeholder="$t('mensagens.operacao.justificativa')",
                            type='textarea',
                            resize='none',
                            :rows='2'
                        )
        .buttons.center-align
            BaseButton(size='mini', @click='closeDialog()')
                | {{ $t('mensagens.comuns.fechar') }}
            BaseButton(type='primary', size='mini', @click='cancelarOperacao')
                | {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import StatusOperacao from '@/constants/StatusOperacao.js';
import OperacaoService from '@/services/OperacaoService.js';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalCancelamentoOperacao',

    components: {
        BaseButton
    },

    emits: ['cancelarOperacao'],

    props: {
        operacao: {
            type: Object,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            justificativa: null
        };
    },

    methods: {
        closeDialog() {
            this.justificativa = null;
            this.$emit('update:show', false);
        },

        async cancelarOperacao() {
            if (this.justificativa == null || this.justificativa.length === 0) {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.preenchaJustificativa')
                });
                return;
            }

            const cancelamentoOperacao = {
                idOperacao: this.operacao.id,
                idStatusOperacao: StatusOperacao.CANCELADO,
                parecer: this.justificativa
            };

            await OperacaoService.atualizarStatus(cancelamentoOperacao)
                .then(() => {
                    this.$notify.success({
                        message: this.$t('mensagens.operacao.notificacao.operacaoCancelada')
                    });
                    this.$emit('cancelarOperacao');
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.cancelarOperacaoFalha')
                    });
                })
                .finally(() => this.closeDialog());
        }
    }
};
</script>

<style lang="scss">
#modal-cancelamento-operacao {

    .center-align {
        text-align: center;
        justify-content: space-between;
        display: flex;
    }

    h4.mb-4 {
        word-break: break-word;
        font-size: 14px !important;
    }

    .el-dialog__footer {
        margin-top: -30px;
        display: flex;
        justify-content: flex-start;
    }

    .mapa {
        height: 150px;
        border-radius: 4px;
        overflow: hidden;
        margin: -20px 0 20px 0;
    }

    .link {
        margin-left: 20px;
        cursor: pointer;

        i {
            display: inline-flex;
            vertical-align: bottom;
            font-style: normal;
            font-size: 13px;
        }
    }

    .margin-p {
        margin-bottom: 0;
    }
}
</style>
